import { appSwitchRoutes } from 'constants/routes';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Authentication } from 'views/Authentication/Authentication';
import CodingAssessmentThankYou from 'views/CodingAssessmentThankYou/CodingAssessmentThankYou';
import ExternalServiceLanding from 'views/ExternalServiceLanding/ExternalServiceLanding';
import { IndirectInvitation } from 'views/IndirectInvitation/IndirectInvitation';
import PersonalSkillsProfile from 'views/PersonalSkillsProfile';
import Role from 'views/Role/Role';
import RoleStageActions from 'views/RoleStageActions/RoleStageActions';
import RoleStageContent from 'views/RoleStageContent/RoleStageContent';
import RoleStageEligibility from 'views/RoleStageEligibility/RoleStageEligibility';
import RoleStageEligibilityIntro from 'views/RoleStageEligibility/RoleStageEligibilityIntro';
import RoleStageCognitiveTest from 'views/RoleStageActions/flows/RoleStageCognitiveTest';
import RoleStageDeiForm from 'views/RoleStageActions/flows/RoleStageDeiForm';
import RoleStageEnglishProficiencyTest from 'views/RoleStageActions/flows/RoleStageEnglishProficiencyTest';
import RoleStageDeiIntro from 'views/RoleStageActions/flows/RoleStageDeiIntro';
import RoleStageCoderbyteAssessmentIntro from 'views/RoleStageActions/flows/RoleStageCoderbyteAssessmentIntro';
import RoleStageForm from 'views/RoleStageActions/flows/RoleStageForm';
import RoleStagePersonalityTest from 'views/RoleStageActions/flows/RoleStagePersonalityTest';
import RoleStageRssAssessment from 'views/RoleStageActions/flows/RoleStageRssAssessment';
import RoleStageThankYou from 'views/RoleStageActions/flows/RoleStageThankYou';
import RoleStageAdjustments from 'views/RoleStageAdjustments/RoleStageAdjustments';
import RoleStageIdentityVerification from 'views/RoleStageIdentityVerification/RoleStageIdentityVerification';
import Roles from 'views/Roles/Roles';
import CandidatePortal from 'views/CandidatePortal/CandidatePortal';
import { ConferencePage } from '../../views/AiInterview/ConferencePage';
import { AiInterviewLegacyRedirect } from '../../views/AiInterview/AiInterviewLegacyRedirect';
import PrivateRoute from '../PrivateRoute/PrivateRoute';
import { ConnectionQualityProvider } from 'components/features/connectionQuality';
import { AutomatedDecisionMaking } from '@/views/AutomatedDecisionMaking/AutomatedDecisionMaking';

const RootRedirection = () => <Navigate to={appSwitchRoutes.roles.path} />;

function AppSwitch() {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            redirectUrl={appSwitchRoutes.authentication.getUrl() + '/sign-up'}
          />
        }
      >
        <Route
          path={appSwitchRoutes.indirectInvitation.path}
          element={<IndirectInvitation />}
        />
      </Route>

      <Route element={<PrivateRoute />}>
        <Route path={appSwitchRoutes.roles.path} element={<Roles />} />
        <Route path={appSwitchRoutes.role.path} element={<Role />} />
        <Route
          path={appSwitchRoutes.candidatePortal.path}
          element={<CandidatePortal />}
        />
        <Route
          path={appSwitchRoutes.roleStageActions.path}
          element={<RoleStageActions />}
        />
        <Route
          path={appSwitchRoutes.roleStageContent.path}
          element={<RoleStageContent />}
        />
        <Route
          path={appSwitchRoutes.roleStageEligibility.path}
          element={<RoleStageEligibilityIntro />}
        />
        <Route
          path={appSwitchRoutes.roleStageEligibilityQuestions.path}
          element={<RoleStageEligibility />}
        />
        <Route
          path={appSwitchRoutes.roleStageAdjustments.path}
          element={<RoleStageAdjustments />}
        />
        <Route
          path={appSwitchRoutes.roleStageIdentityVerification.path}
          element={<RoleStageIdentityVerification />}
        />
        <Route
          path={appSwitchRoutes.roleStagePersonalityTest.path}
          element={<RoleStagePersonalityTest />}
        />
        <Route
          path={appSwitchRoutes.roleStageCognitiveTest.path}
          element={<RoleStageCognitiveTest />}
        />
        <Route
          path={appSwitchRoutes.roleStageEnglishProficiencyTest.path}
          element={<RoleStageEnglishProficiencyTest />}
        />
        <Route
          path={appSwitchRoutes.roleStageRssAssessment.path}
          element={<RoleStageRssAssessment />}
        />
        <Route
          path={appSwitchRoutes.roleStageDeiIntro.path}
          element={<RoleStageDeiIntro />}
        />
        <Route
          path={appSwitchRoutes.roleStageDeiForm.path}
          element={<RoleStageDeiForm />}
        />
        <Route
          path={appSwitchRoutes.roleStageForm.path}
          element={<RoleStageForm />}
        />
        <Route
          path={appSwitchRoutes.roleStageCoderbyteAssessment.path}
          element={<RoleStageCoderbyteAssessmentIntro />}
        />
        <Route
          path={appSwitchRoutes.roleStageThankYou.path}
          element={<RoleStageThankYou />}
        />

        <Route
          path={appSwitchRoutes.personalSkillsProfile.path}
          element={<PersonalSkillsProfile />}
        />
        <Route
          path={appSwitchRoutes.codingAssessmentThankYou.path}
          element={<CodingAssessmentThankYou />}
        />

        <Route
          path={appSwitchRoutes.aiInterview.path}
          element={
            <ConnectionQualityProvider>
              <ConferencePage />
            </ConnectionQualityProvider>
          }
        />

        <Route
          path={appSwitchRoutes.aiInterviewLegacy.path}
          element={<AiInterviewLegacyRedirect />}
        />

        <Route path="/" element={<RootRedirection />} />
      </Route>

      <Route
        path={appSwitchRoutes.authentication.path}
        element={<Authentication />}
      />
      <Route
        path={appSwitchRoutes.externalService.path}
        element={<ExternalServiceLanding />}
      />

      <Route
        path={appSwitchRoutes.automatedDecisionMaking.path}
        element={<AutomatedDecisionMaking />}
      />
    </Routes>
  );
}

export default AppSwitch;
